import {computed,observable,autorun,runInAction} from 'mobx';
import InputModel from '../models/InputModel'
import SelectionModel from '../models/SelectionModel'
import CommonEntriesStore from './CommonEntriesStore'
import BaseEntriesStore from './BaseEntriesStore'
import BrespaAnalyseStore from './BrespaAnalyseStore'
import OutputModel from '../models/OutputModel'
import PrintOutput from "../models/PrintOutput";
import Utils from "../utils/Utils";


class HalbfertigAnalyseStore extends CommonEntriesStore{
    constructor(){
        super();
        this.basenentries = BaseEntriesStore;
        this.baseentries = BaseEntriesStore;
        this.brespastore = BrespaAnalyseStore;
    }
    title = "Einzelpositionen";

    @observable
    baseentries;
    @observable
    brespastore = null;

    @observable
    lohnkosten = new InputModel('Lohnkosten',1,'');
    @observable
    preis_elementdecke = new InputModel('Preis Elementdecke frei Bau',1,'');
    @observable
    decke_abladen = new InputModel('Elementdeckenplatten abladen und lagern',1,'');
   /* @observable
    platten_verlegen = new InputModel('Elementdeckenplatten verlegen',1,'');*/
    @observable
    krankosten = new InputModel('Krankosten',1,'');
    @observable
    joche_stellen = new InputModel('Joche stellen unc ausbauen',1,'');
    @observable
    dicke_elemente = new InputModel('Dicke der Elementdecke',1,'');
    @observable
    spachteln_streichen = new InputModel('Spachteln und Streichen der Unterseite',1,'');
    @observable
    stahl_eingebaut = new InputModel('Stahl eingebaut',1,'');

    @observable personal_montage = new InputModel('Personal Montage',"enthalten","St.",true,false,null,true);



    @computed get totalKostenStuetzung(){
        var out = new OutputModel("Mehrkosten für zusätzlich <br/>erforderliche Deckenauflager","Mehrkosten für zusätzlich <br/>erforderliche Deckenauflager",0.0,'€/m²');
        return out;
    }
    @computed get totalValueBrespa(){
        var out =  new OutputModel("Gesamtkosten für " + this.basenentries.dicke_erforderlich_brespa.value +' cm Decke',"Gesamtkosten für" + this.basenentries.dicke_erforderlich_brespa.value +' cm Decke',0.0,'€/m²');
        return out;
    }

    get totalDicke(){
        return this.baseentries.totalDicke
    }

    @observable entries = [
        this.preis_elementdecke,
        this.personal_montage,
        this.stahl_eingebaut,
        this.decke_abladen,
        this.joche_stellen,
        this.krankosten,
        this.spachteln_streichen

    ];
    @computed get randschalung(){
        let k = this.lohnkosten ;
        return  new InputModel("lfd. m <br/>Randschalung <br/>(20 bis 32 cm)",0.45 * this.lohnkosten.value +5 ,''+k.einheit);
    }

    updateData = autorun(() => {
        console.log("updating HAlbfertig")
        if(!this.basenentries || !this.basenentries.eingabefelder.halbfertigteil){return}
        console.log("updating HAlbfertig after")
        let daten = this.basenentries.daten;
        //this.brespaselection.setOptions(SelectionModel.createOptionsFromObjectArray(daten.brespaplatten),0);
        let felder = this.basenentries.eingabefelder.halbfertigteil;
        if(!felder){return}

        for (let key in felder) {
            if( this.hasOwnProperty( key ) ) {
                //console.log("setting: ", key)
                runInAction(() => {
                    this[key].value = felder[key].value;
                    this[key].einheit = felder[key].einheit;
                    this[key].disabled = !felder[key].editable;
                    this[key].title = felder[key].title;
                });

            }
        };
        this.entries.push(this.entries.pop())
        //this.calcKosten()
    },{ delay: 200 });


    @observable
    bew_oben_eq_brespa = 0;
    @observable
    bew_unten_eq_brespa = 0;
    @observable
    bew_oben_eq_sp = 0;
    @observable
    bew_unten_eq_sp = 0;
    @observable
    kosten_einsaetze = 0;
    @observable
    aussparungen = 0;
    @observable
    flaeche_abziehen = 0;


    print_montagekosten= null;
    print_kostenelementfreib= null;
    print_stahleing= null;
    print_mattenbewehrung= null;
    print_zeit_mattenbewehrung= null;
    print_stahlbewehrung= null;
    print_zeit_stahlbewehrung= null;
    print_betonc20= null;
    print_betonieren= null;
    print_zeit_autokran= null;
    print_abziehen= null;
    print_schalungaussp= null;
    print_mehrkostenauflager= null;
    print_randschalung= null;
    print_zeit_montage_element= null;
    print_kostenjoche= null;
    print_krankosten= null;
    print_endbehandlungunten= null;
    print_zeit_total = 0;
    print_material_total = 0;
    needsStuetzung = false;


    print_dauerherstellung = null;

    calckosten = autorun(() => {
        if(!this.basenentries || !this.basenentries.daten.halbfertig ){
            return
        }
        this.print_zeit_total = 0;
        this.print_material_total = 0;
        let ml = this.brespastore.max_laenge_other;
        let mgs = this.basenentries.masgebendestuetzweite;
        let hfdaten = this.basenentries.daten.halbfertig;
        let deckefb = this.preis_elementdecke.value;
        let kost_gt = this.basenentries.daten.halbfertig.gitter.value * 5.5;
        let deckenfl = this.basenentries.deckenflaeche.value;


        let faktorbew = Math.pow(Math.max(hfdaten.standardlaenge,this.brespastore.max_laenge_other),2) / Math.pow(hfdaten.standardlaenge,2);
        let standard_unten = faktorbew * hfdaten.standardbew_unten;
        let standard_oben = faktorbew * hfdaten.standardbew_oben;
        let bew_dicke_brespa = standard_oben+standard_unten;


        let faktorbew_eq_spannw =  Math.pow(this.basenentries.masgebendestuetzweite,2) / Math.pow(this.brespastore.max_laenge_other,2);
        let standard_unten_eq_spannw = faktorbew_eq_spannw * standard_unten;
        let standard_oben_eq_spannw = faktorbew_eq_spannw * standard_oben;
        let bew_dicke_eq_spannw = standard_unten_eq_spannw+standard_oben_eq_spannw;


        let kost_bew_eq_spannw = this.stahl_eingebaut.value * standard_unten_eq_spannw ;
        let kost_bew_eq_brespa = this.stahl_eingebaut.value * standard_unten ;

        let kost_bew_oben_eq_spannw = this.basenentries.baustahlpreisStab.value * standard_oben_eq_spannw*0.3 + this.basenentries.baustahlpreisMatten.value * standard_oben_eq_spannw*0.7;//this.basenentries.baustahlpreisStab.value * standard_oben_eq_spannw ;
        //let kost_bew_oben_eq_brespa = this.basenentries.baustahlpreisStab.value * standard_oben ;
        let kost_bew_oben_eq_brespa = this.basenentries.baustahlpreisStab.value * standard_oben*0.3 + this.basenentries.baustahlpreisMatten.value * standard_oben*0.7  ;



       // let bew = 5.38 * 1.2;
        let erfdecke = this.basenentries.erf_deckendicke;

        this.basenentries.dickeforderlichhf.value = erfdecke;
        this.basenentries.dickeforderlichob.value = erfdecke;
        this.basenentries.entries4.push(this.basenentries.entries4.pop())

        let toofat  = (this.basenentries.dickeforderlichob.value - this.brespastore.plattendicke.value > 8);



       // pin = toofat?kost_bew_eq_brespa:kost_bew_eq_spannw;


        let kosten_beton = (erfdecke - this.dicke_elemente.value)/100 * this.basenentries.betonpreis.value*1.03;
        let kosten_beton_eq_brespa = (this.brespastore.plattendicke.value - this.dicke_elemente.value)/100 * this.basenentries.betonpreis.value*1.03;
        let betonproqm = (erfdecke/100 - 0.05)*1.03;


       // let elemente_lagern = this.lohnkosten.value * this.decke_abladen.value /2.5/5.0;
        let montage = this.lohnkosten.value * this.decke_abladen.value /(2.5*mgs);

        let montage_eq_brespa = (this.lohnkosten.value * this.decke_abladen.value) / ((2.5*(ml>mgs)?mgs:ml));

        let numeinsaetze = this.basenentries.anzahldecken.value;
        let kosten_einsaetze = this.basenentries.ruestzeiten_pumpe.value *
            (this.krankosten.value + (this.brespastore.personal_montage.value * this.lohnkosten.value))* numeinsaetze / this.basenentries.deckenflaeche.value;

        this.print_autokran = new PrintOutput(Utils.roundToTwo(kosten_einsaetze) + "h/Einsatz",numeinsaetze+"Einsätze",Utils.roundToTwo(kosten_einsaetze*numeinsaetze),"€");

        let unterseite = this.spachteln_streichen.value;
        let joche = this.joche_stellen.value * this.lohnkosten.value;
        let aussparungen = this.basenentries.aussparungen_einbauen.value * this.lohnkosten.value/10.0;

        let beton_einbauen = this.basenentries.betonieren_transportbeton.value * this.lohnkosten.value*(erfdecke-this.dicke_elemente.value)/100.0;
        let beton_einabuen_eq_brespa = this.basenentries.betonieren_transportbeton.value * this.lohnkosten.value*(this.brespastore.plattendicke.value-this.dicke_elemente.value)/100.0;


        let flaeche_abziehen = this.basenentries.oberflaeche_abziehen.value * this.lohnkosten.value;

        let m_krankosten = 1.6+(erfdecke-20)*0.001*this.krankosten.value;
        let m_krankosten_eq_brespa = 1.6+(this.brespastore.plattendicke.value-20)*0.01*this.krankosten.value;


        let zulage_mehrdicke = 1.9*(this.dicke_elemente.value-5);
        let randschalung_meter = this.basenentries.anzahldecken.value* (this.basenentries.geblaenge.value+this.basenentries.gebbreite.value)*2;
        let kostenrandschalung = randschalung_meter * this.basenentries.randschalung_eingabe.value / this.basenentries.deckenflaeche.value;
        let deckenfl_total = deckenfl * this.basenentries.anzahldecken.value;
        /*
        * (montage(_eq_brespa)*Fläche/lohnkosten + joche * Fläche/lohnkosten
aus Eingabefeld 'Bewehrung BSt-Matten einbauen 9 h/t* standard_oben_eq_spannw*0,25* Fläche/1000
aus Eingabefeld 'Bewehrung BSt-Matten einbauen 9 h/t* standard_oben_eq_spannw*0,75/1000
beton_einbauen * Fläche/lohnkosten + Fläche_abziehen*Fläche/Lohnkosten + Aussparungen * Fläche/Lohnkosten)*Lohnkosten
        * */
        let pin2 = toofat?beton_einabuen_eq_brespa:beton_einbauen;
        let sin_mon = toofat ? montage_eq_brespa : montage;
        let bewbst = this.basenentries.bewehrung_einbauen.value;
        let lohnkosten = this.lohnkosten.value;
        let p_m = ((sin_mon*deckenfl/lohnkosten)
            + (joche * deckenfl/lohnkosten)
            + (bewbst*standard_oben_eq_spannw*0.25*deckenfl/1000)
            + (bewbst*standard_oben_eq_spannw*0.75*deckenfl/1000)
            + (pin2 *deckenfl/lohnkosten) + (flaeche_abziehen * deckenfl/lohnkosten) + (aussparungen * deckenfl/lohnkosten));
        this.print_montagekosten= new PrintOutput(Utils.rAndF(lohnkosten)+ "€/h",Utils.rAndF(p_m)+"h" , Utils.rAndF(p_m * lohnkosten),"€");

        var zeittotal = 0;
        var preistotal = 0;

        this.print_kostenelementfreib = new PrintOutput(Utils.rAndF(deckefb+kost_gt)+ " €/m²",Utils.rAndFNoDec(deckenfl)+" m²" , Utils.rAndF((deckefb+kost_gt)*deckenfl),"€");
        preistotal += (deckefb+kost_gt)*deckenfl
        let sin_bew = toofat ? kost_bew_eq_brespa : kost_bew_eq_spannw;
        let sin_stahl = toofat ? standard_unten : standard_unten_eq_spannw;
        this.print_stahleing = new PrintOutput(Utils.rAndF(sin_stahl)+ " kg/m²",Utils.rAndF(this.stahl_eingebaut.value)+" €/kg x " + Utils.rAndFNoDec(deckenfl)+" m²" , Utils.rAndF(sin_stahl*this.stahl_eingebaut.value*deckenfl),"€");
        preistotal += sin_stahl*this.stahl_eingebaut.value*deckenfl;
        let sin_bew_oben = toofat ? kost_bew_oben_eq_brespa : kost_bew_oben_eq_spannw;
        let sin_matte = toofat ? standard_oben : standard_oben_eq_spannw;
        this.print_mattenbewehrung = new PrintOutput(Utils.rAndF(sin_matte * 0.7 ) + " kg/m²",this.basenentries.baustahlpreisMatten.value+" €/kg x " + Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF(sin_matte * 0.7*deckenfl*this.basenentries.baustahlpreisMatten.value),"€");
        preistotal += sin_matte * 0.7*deckenfl*this.basenentries.baustahlpreisMatten.value;
        var pin = sin_matte * 0.3;// toofat?kost_bew_oben_eq_brespa:kost_bew_oben_eq_spannw
        this.print_stahlbewehrung = new PrintOutput(Utils.rAndF(pin) + " kg/m²",this.basenentries.baustahlpreisStab.value+" €/kg x " + Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF(pin*deckenfl*this.basenentries.baustahlpreisStab.value),"€");
        preistotal += pin*deckenfl*this.basenentries.baustahlpreisStab.value ;
        this.print_zeit_mattenbewehrung= new PrintOutput("","",Utils.rAndF(sin_matte  *deckenfl/1000)+" t x "+ Utils.rAndF(bewbst)+" h/t = "+Utils.rAndF((bewbst * sin_matte*deckenfl/1000))+" h","",true);
        zeittotal += bewbst * sin_matte * deckenfl/1000;
        /*this.print_zeit_stahlbewehrung= new PrintOutput("","",Utils.rAndF(bewbst )+"h/t. x "+ Utils.rAndF(standard_oben_eq_spannw * 0.25/1000)+"t = "+Utils.rAndF((bewbst * standard_oben_eq_spannw * 0.25/1000))+"h","",true);
        zeittotal += bewbst * standard_oben_eq_spannw * 0.25 / 1000;*/

        pin = toofat?kosten_beton_eq_brespa:kosten_beton;
        this.print_betonc20 = new PrintOutput(Utils.rAndF(betonproqm) + " m³/m² ",this.basenentries.betonpreis.value+" €/m³ x " + Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF(betonproqm*this.basenentries.betonpreis.value*deckenfl),"€");
        preistotal += betonproqm*this.basenentries.betonpreis.value*deckenfl;
        this.print_betonieren = new PrintOutput("","",Utils.rAndF(betonproqm*deckenfl) + " m³ x "+this.basenentries.betonieren_transportbeton.value+" h/m³ = "+ Utils.rAndF(betonproqm*deckenfl*this.basenentries.betonieren_transportbeton.value)+" h","",true);
        zeittotal += betonproqm*deckenfl*this.basenentries.betonieren_transportbeton.value;
        this.print_zeit_autokran= new PrintOutput("","",numeinsaetze + " Gesch. x "+Utils.rAndF(this.baseentries.ruestzeiten_pumpe.value)+" h/Gesch. = "+ Utils.rAndF(numeinsaetze *this.baseentries.ruestzeiten_pumpe.value*4) + " h","",true);
        zeittotal += numeinsaetze *this.baseentries.ruestzeiten_pumpe.value*4;

        this.print_abziehen = new PrintOutput("","", Utils.rAndF(this.basenentries.oberflaeche_abziehen.value) + " h/m² x "+Utils.rAndFNoDec(deckenfl)+" m²" +" = "+Utils.rAndF(this.basenentries.oberflaeche_abziehen.value*deckenfl)+" h","",true);
        zeittotal += this.basenentries.oberflaeche_abziehen.value*deckenfl;
        this.print_schalungaussp = new PrintOutput("","",Utils.rAndFNoDec(Math.ceil(deckenfl/10)) + " x "+ Utils.rAndF(this.baseentries.aussparungen_einbauen.value) + " h/St. = "+Utils.rAndF( this.baseentries.aussparungen_einbauen.value * Math.ceil(deckenfl/10))+" h" ,"",true);
        zeittotal += this.baseentries.aussparungen_einbauen.value * Math.ceil(deckenfl/10);


        this.print_randschalung = new PrintOutput(Utils.rAndF(randschalung_meter)+" m",Utils.rAndF(this.basenentries.randschalung_eingabe.value) + " €/m",Utils.rAndF((this.basenentries.randschalung_eingabe.value)*randschalung_meter),"€");
        preistotal += this.basenentries.randschalung_eingabe.value*randschalung_meter
        this.print_zeit_montage_element= new PrintOutput("","",Utils.rAndF(deckenfl/(2.5*mgs))+" x "+this.decke_abladen.value+" h/St = "+Utils.rAndF((deckenfl/(2.5*mgs)) *this.decke_abladen.value)+" h","",true);
        zeittotal += (deckenfl/(2.5*mgs)) *this.decke_abladen.value;

        this.print_kostenjoche = new PrintOutput("","",Utils.rAndF(this.joche_stellen.value)+" h/m² "+ Utils.rAndFNoDec(deckenfl) + " m² x "+ " = "+ Utils.rAndF(this.joche_stellen.value * deckenfl)+" h","",true);
        zeittotal += this.joche_stellen.value*deckenfl
        this.print_krankosten = new PrintOutput(Utils.rAndF(m_krankosten*deckenfl/this.krankosten.value + (numeinsaetze * this.basenentries.ruestzeiten_pumpe.value)) + " h",this.krankosten.value+" €/h",
            Utils.rAndF(((m_krankosten*deckenfl/this.krankosten.value) + (numeinsaetze * this.basenentries.ruestzeiten_pumpe.value)) *this.krankosten.value ),"€");
       // preistotal += (m_krankosten*deckenfl/this.krankosten.value) *this.krankosten.value;
        this.print_endbehandlungunten = new PrintOutput(Utils.rAndF(unterseite) + " €/m²",Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF(unterseite*deckenfl),"€");
       // preistotal += unterseite*deckenfl;

        this.print_material_total = preistotal;
        this.print_zeit_total = zeittotal;



        var total_brespa = 0;
        var total_eq_sp = 0;
        console.groupCollapsed("Halbfertig Kosten:::::::::::");
        console.group("Gleiche dicke wie Brespa");
        console.log("Faktor Bewehrung", faktorbew);
        console.log("Maßgebende SW", mgs);
        console.log("Maxlaenge", ml);
        console.log("Erf Deckendicke", erfdecke);
        console.log("addieren von:");
        console.log("Decke frei bau", deckefb);
        console.log("Kosten Gitter", kost_gt);
        console.log("Kosten Bewehrung", kost_bew_eq_brespa);
        console.log("Kosten Bewehrung oben", kost_bew_oben_eq_brespa);
        console.log("Kosten Beton", kosten_beton_eq_brespa);
        console.log("Montage", montage);
        console.log("Kosten einsätze", kosten_einsaetze);
        console.log("Unterseite", unterseite);
        console.log("Joche", joche);
        console.log("Aussparungen", aussparungen);
        console.log("Beton einbauen", beton_einabuen_eq_brespa);
        console.log("Fläche abziehen", flaeche_abziehen);
        console.log("Zulage Mehrdicke", zulage_mehrdicke);
        console.log("Randschalung", kostenrandschalung);
        console.log("Krankosten", m_krankosten_eq_brespa);
        total_brespa = deckefb + kost_gt + kost_bew_eq_brespa + kost_bew_oben_eq_brespa + kosten_beton_eq_brespa  + montage_eq_brespa +
            kosten_einsaetze + unterseite + joche + aussparungen + beton_einabuen_eq_brespa + flaeche_abziehen + zulage_mehrdicke + kostenrandschalung + m_krankosten_eq_brespa;
        console.log("----TOTAL---: ", total_brespa );
        console.groupEnd()
        console.group("Normal");
        console.log("Faktor Bewehrung", faktorbew_eq_spannw);
        console.log("addieren von:");
        console.log("Decke frei bau", deckefb);
        console.log("Kosten Gitter", kost_gt);
        console.log("Kosten Bewehrung", kost_bew_eq_spannw);
        console.log("Kosten Bewehrung oben", kost_bew_oben_eq_spannw);
        console.log("Kosten Beton", kosten_beton);
        console.log("Montage", montage);
        console.log("Kosten einsätze", kosten_einsaetze);
        console.log("Unterseite", unterseite);
        console.log("Joche", joche);
        console.log("Aussparungen", aussparungen);
        console.log("Beton einbauen", beton_einbauen);
        console.log("Fläche abziehen", flaeche_abziehen);
        console.log("Zulage Mehrdicke", zulage_mehrdicke);
        console.log("Randschalung", kostenrandschalung);
        console.log("Krankosten", m_krankosten);
        total_eq_sp = deckefb + kost_gt + kost_bew_eq_spannw + kost_bew_oben_eq_spannw + kosten_beton + montage +
            kosten_einsaetze + unterseite + joche + aussparungen + beton_einbauen + flaeche_abziehen + zulage_mehrdicke + kostenrandschalung + m_krankosten;
        console.log("----TOTAL---: ", total_eq_sp );
        console.groupEnd()
        console.group("ZUsaätzliche Stützung");
        let geblaenge = this.basenentries.geblaenge.value;
        let gebbreite = this.basenentries.gebbreite.value;


        let num_stuetzung = Math.round(geblaenge *((geblaenge / ml) / (geblaenge / mgs) - 1) / ml );
        console.log("Stützungen", num_stuetzung);
        let kosten_stuetzung = this.basenentries.kosten_stuetzung.value * num_stuetzung * gebbreite / (geblaenge * gebbreite)
        console.log("Kosten der Stützungen", kosten_stuetzung);
        console.groupEnd();
        console.groupEnd();

        this.needsStuetzung = (num_stuetzung*geblaenge*numeinsaetze) > 0 ;
        this.print_mehrkostenauflager = new PrintOutput(Utils.rAndFNoDec(num_stuetzung*geblaenge*numeinsaetze)+" lfd.m",Utils.rAndFNoDec(this.basenentries.kosten_stuetzung.value) + " €/lfd.m",Utils.rAndF(this.basenentries.kosten_stuetzung.value * num_stuetzung*geblaenge*numeinsaetze),"€");


                this.totalValue.value = total_eq_sp;
        this.totalValueBrespa.value = total_brespa;
        this.totalKostenStuetzung.value = Math.round(kosten_stuetzung);
        this.totalValueBrespaStuetzung.value = total_brespa + Math.round(kosten_stuetzung);

        this.bew_oben_eq_brespa = standard_oben;
        this.bew_unten_eq_brespa = standard_unten;
        this.bew_oben_eq_sp = standard_oben_eq_spannw;
        this.bew_unten_eq_sp = standard_unten_eq_spannw;
        this.kosten_einsaetze = kosten_einsaetze;
        this.aussparungen = aussparungen;
        this.flaeche_abziehen = flaeche_abziehen;
        if(this.baseentries != null){

        this.baseentries.detailEntries.push(this.baseentries.detailEntries.pop());
        }

    },{ delay: 200 })




}
export default new HalbfertigAnalyseStore();




// WEBPACK FOOTER //
// ./src/stores/HalbfertigAnalyseStore.js